import { render, staticRenderFns } from "./ImportantEventsPortlet.vue?vue&type=template&id=03000f27&"
import script from "./ImportantEventsPortlet.vue?vue&type=script&lang=js&"
export * from "./ImportantEventsPortlet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports